import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemAndWhatIs } from './components/ProblemAndWhatIs';
import { TomosGrid } from './components/TomosGrid';
import { Testimonials } from './components/Testimonials';
import { BonusesSection } from './components/BonusesSection';
import { PurchaseSection } from './components/PurchaseSection';
import { PurchasePopup, Footer } from './components/Shared';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as unknown as {
      fbq?: any;
      _fbq?: any;
    };
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    const fbq: any = function () {
      // eslint-disable-next-line prefer-rest-params
      fbq.callMethod ?
      // eslint-disable-next-line prefer-rest-params
      fbq.callMethod.apply(fbq, arguments) :
      // eslint-disable-next-line prefer-rest-params
      fbq.queue.push(arguments);
    };
    w.fbq = fbq;
    if (!w._fbq) w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (document.head || document.documentElement).appendChild(script);
    w.fbq('init', '2069197916973057');
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-forest-950 text-forest-100 font-inter selection:bg-yellow-400/30" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2069197916973057&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <Hero data-id="element-3" />
      <ProblemAndWhatIs data-id="element-4" />
      <TomosGrid data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <PurchaseSection data-id="element-7" />
      <Testimonials data-id="element-8" />
      <Footer data-id="element-9" />
      <PurchasePopup data-id="element-10" />
    </div>;
}